import { sendPage } from "./adp";

/**
 * The only function app code calls to emit an event. A no-op unless analytics is
 * enabled and the user opted in; never throws. Tier 2 events extend this.
 */
export function track(eventName: string, properties?: Record<string, unknown>): void {
    try {
        sendPage(eventName, properties);
    } catch {
        // Analytics must never affect the app.
    }
}
